import React, { Component } from 'react'
import { connect } from 'react-redux'
import download from 'downloadjs'
import { Card } from '@myxplor/ui'
import { errorsObject } from '@myxplor/payload-helpers'

import { fetchWithRetry } from '../authorisation'
import ExportForm from './views/form'
import Complete from './views/complete'

const apiPath = () => (
  `${process.env.REACT_APP_API_HOST}/api/gov-enrolments/export`
)

const defaultState = {
  loading: false,
  complete: false,
  errors: {}
}

export class Export extends Component {
  constructor(props) {
    super(props)
    this.downloadCSV = this.downloadCSV.bind(this)
    this.exportAnother = this.exportAnother.bind(this)
    this.state = defaultState
  }

  downloadCSV(params) {
    this.setState({ loading: true })

    return fetchWithRetry(
      apiPath(params.resourceIDs),
      {
        method: 'POST',
        token: this.props.tokens.jwt,
        accept: 'text/csv',
        body: {
          data: {
            type: 'gov-enrolments',
            attributes: params.payload
          }
        }
      }, this.props.dispatchAction
    )
      .then(response => {
        if (response.ok) {
          response.blob().then(csvData => {
            download(csvData, 'export.csv', 'text/csv')
            this.setState({
              ...defaultState,
              complete: true,
              loading: false
            })
          })
        } else {
          response.json().then(payload => {
            this.setState({
              errors: errorsObject(payload.errors),
              loading: false
            })
          })
        }
      })
  }

  exportAnother(e) {
    e.preventDefault()
    this.setState(defaultState)
  }


  render() {
    const {
      loading,
      errors,
      complete
    } = this.state

    return (
      <Card title="Export">
        {
          complete ?
            <Complete onClick={this.exportAnother} /> :
            <ExportForm loading={loading} errors={errors} submitAction={this.downloadCSV} />
        }
      </Card>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchAction: (action) => dispatch(action)
})

const mapStateToProps = (state) => ({
  tokens: {
    jwt: state.authorisation.jwt
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Export)




// WEBPACK FOOTER //
// ./src/export/index.js